var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H3C1.35 0 0 1.35 0 3V24C0 25.65 1.35 27 3 27H24C25.65 27 27 25.65 27 24V3C27 1.35 25.65 0 24 0ZM9.75 12.75C9.75 13.95 8.7 15 7.5 15H6V18H3.75V9H7.5C8.7 9 9.75 10.05 9.75 11.25V12.75ZM17.25 15.75C17.25 16.95 16.2 18 15 18H11.25V9H15C16.2 9 17.25 10.05 17.25 11.25V15.75ZM23.25 11.25H21V12.75H23.25V15H21V18H18.75V9H23.25V11.25ZM13.5 11.25H15V15.75H13.5V11.25ZM6 11.25H7.5V12.75H6V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.adff2b0351b6ab0b234c070e92791a72.svg";
export { ForwardRef as ReactComponent };